import React from 'react';
import { ListenerState, PeerType } from '../../hooks/usePeers';

interface UserTypeIconProps {
  state: ListenerState;
}

const UserTypeIcon: React.FC<UserTypeIconProps> = ({ state }) => {
  const isListener = state === PeerType.ACTIVE_LISTENER;
  const isApplicant = state === PeerType.ONBOARDING_PEER || state === PeerType.UPGRADING_PEER;

  const label = isListener ? 'Listener' : isApplicant ? 'Applicant' : 'Peer';

  const iconColor = isListener ? 'text-blue-600' : isApplicant ? 'text-yellow-600' : 'text-purple-600';

  return (
    <div className="group relative flex items-center">
      <svg
        className={`h-5 w-5 ${iconColor}`}
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
      </svg>
      <span className="invisible absolute bottom-full left-1/2 z-10 mb-2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white group-hover:visible">
        {label}
      </span>
    </div>
  );
};

export default UserTypeIcon;
